import { isOk } from '@/common/utils';
import { graphqlRequest } from '../urql';
import {
  generateAIImageMutation,
  saveAIBackgroundMutation,
  saveAIClipartMutation
} from './mutations';
import { get } from 'lodash';
import { BackgroundElementEntity as BackgroundElement } from '@/common/models/entities/elements';
import { apiBackgroundToModel } from '@/common/mapping';
import { BACKGROUND_TYPE } from '@/common/constants';

export const mapBackgrounds = backgrounds => {
  return backgrounds.map(
    item =>
      new BackgroundElement({
        ...apiBackgroundToModel(item),
        backgroundType: BACKGROUND_TYPE.CUSTOM.id
      })
  );
};

export const createAIImageApi = async params => {
  const res = await graphqlRequest(generateAIImageMutation, {
    ...params,
    amount: 4
  });

  if (!isOk(res)) return;

  return get(res, 'data.create_bedrock_image', {});
};

export const saveAIBackgroundApi = async (urls, id) => {
  const res = await graphqlRequest(saveAIBackgroundMutation, {
    urls,
    id: +id
  });

  if (!isOk(res)) return;

  const backgrounds = get(res, 'data.select_ai_generated_backgrounds', []);

  return mapBackgrounds(backgrounds);
};

export const saveAIClipartApi = async (urls, id) => {
  const res = await graphqlRequest(saveAIClipartMutation, {
    urls,
    id: +id
  });

  if (!isOk(res)) return;

  const cliparts = get(res, 'data.select_ai_generated_clipart', []);

  return cliparts.map(c => ({ ...c, imageUrl: c.large_url }));
};
